// ONYX-CUSTOM: restarts hosted videos at the cut point from their alt text (snippets/onyx-video-cut.liquid)
(() => {
  // Listeners sit on document in the capture phase because media events do not bubble, and most
  // <video> elements are inserted late (video-element clones them from a <template> on first play).
  const framesWatched = new WeakSet();

  const cutAt = (video) => Number(video.closest('[data-onyx-cut-at]')?.dataset.onyxCutAt);

  const enforce = (video) => {
    const cut = cutAt(video);
    if (!(cut > 0) || video.seeking || video.currentTime < cut) return;

    video.currentTime = 0;
    if (!video.loop) video.pause();
  };

  document.addEventListener(
    'timeupdate',
    (event) => {
      if (event.target instanceof HTMLVideoElement) enforce(event.target);
    },
    true
  );

  // timeupdate fires only every ~250 ms; per-frame checks keep the overshoot to one frame where supported.
  if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
    document.addEventListener(
      'playing',
      (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement) || framesWatched.has(video) || !(cutAt(video) > 0)) return;

        framesWatched.add(video);
        const onFrame = () => {
          enforce(video);
          video.requestVideoFrameCallback(onFrame);
        };
        video.requestVideoFrameCallback(onFrame);
      },
      true
    );
  }
})();
